// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2ujgl","addWidgetButton":"Header_addWidgetButton__34BEe","dashboardTabs":"Header_dashboardTabs__2wWhu","active":"Header_active__1hFwq"};